module.exports = __webpack_public_path__ + "img/light_file.2730cc08.svg";